<template>
  <footer>
    <section class="copyright-section">
      <b-container>
        <b-row>
          <b-col col xs="6" sm="6" md="6" lg="6">
            <div class="copyright-link">
            <a class="footer-link" href="https://doc-hosting.flycricket.io/back-to-the-stars-privacy-policy/97dc5e64-769e-410b-8b25-12fd22dc212e/privacy" target="_blank">{{$t('privacy_policy')}}</a>
              <!--<router-link class="footer-link" to="/privacy-policy">{{$t('privacy_policy')}}</router-link>-->
              <span>|</span>
              <a class="footer-link" href="https://doc-hosting.flycricket.io/back-to-the-stars-terms-of-use/1f7acf91-6748-4f46-a054-d89fd58af9d4/terms" target="_blank">{{$t('terms_conditions')}}</a>
              <!--<router-link class="footer-link" to="/conditions">{{$t('terms_conditions')}}</router-link>-->
            </div>
          </b-col>
          <b-col col xs="6" sm="6" md="6" lg="6">
            <div class="copyright-text-box">
              <p class="copyright-text">by Viktor Storozhuk</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .copyright-section{
    background: #20201E;
    padding: 40px 0;
    .copyright-link {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #FFF;
      gap: 4px;
      .footer-link{
        color: #FFF;
        font-family: $main-font;
        font-size: 24px;
        text-align: center;
        font-style: normal;
        font-weight: 300;
        line-height: 28.8px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 19.2px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 24px;
          line-height: 28.8px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
    .copyright-text-box{
      display: flex;
      justify-content: flex-end;
      @media screen and (min-width: 768px) {
        justify-content: flex-start;
      }
      @media screen and (min-width: 992px) {
        justify-content: flex-end;
      }
    }
    .copyright-text{
      color: #FFF;
      font-family: $main-font;
      font-size: 24px;
      text-align: center;
      font-style: normal;
      font-weight: 300;
      line-height: 28.8px;
      margin: 0;
      @media screen and (min-width: 320px) {
        width: 197px;
        text-align: left;
        font-size: 16px;
        line-height: 19.2px;
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 1440px) {
        width: 295px;
        font-size: 24px;
        line-height: 28.8px;
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
</style>
